// @core/api/endpoints/workflow/list_executions.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListExecutionsResponse,
} from '../../../types/workflow';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/workflow';

/**
 * List pipeline executions
 * Returns execution history for a pipeline. Supports filtering by status and date range.
 */
export async function ListExecutions(
  pipeline_id: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListExecutionsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/workflows/pipelines/:pipeline_id/executions`;
  requestPath = requestPath.replace(':pipeline_id', encodeURIComponent(pipeline_id));
  const requestOptions = options;
  return client.get<ListExecutionsResponse>(requestPath, { ...requestOptions, params });
}
